/**
 * `cn` mora em `@tami/ui/cn` — era a mesma função escrita aqui e no mobile.
 * Continua exportado daqui para os 300 arquivos que já a importam.
 */
export { cn } from "@tami/ui/cn";

import { getLocale } from "@tami/core";
import { WEB_ERRORS_COPY } from "@/lib/web-errors.copy";

/**
 * Subiu para `@tami/core/intl` — o mobile repetia a mesma chamada com outro
 * nome (`formatCurrencyBRL`). Continua exportado daqui para quem já importa
 * `formatCurrency` de `@/lib/utils`.
 */
export { formatCurrency } from "@tami/core";

export function parseCurrency(input: string): number {
  const clean = input.replace(/[^\d,]/g, "").replace(",", ".")
  return Number.parseFloat(clean) || 0
}

export function formatDate(date: Date | string): string {
  const dateObj = date instanceof Date ? date : new Date(date);
  return new Intl.DateTimeFormat(getLocale()).format(dateObj);
}

export function formatDateTime(date: Date | string): string {
  // Verificar se a data é válida antes de formatar
  try {
    const dateObj = date instanceof Date ? date : new Date(date);

    // Verificar se a data é válida
    if (isNaN(dateObj.getTime())) {
      return WEB_ERRORS_COPY.invalidDate;
    }

    return new Intl.DateTimeFormat(getLocale(), {
      dateStyle: "short",
      timeStyle: "short",
    }).format(dateObj);
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return WEB_ERRORS_COPY.invalidDate;
  }
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 9)
}

export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}